/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Menu_SyncInputs */

const cs_calendar_menu_sync = /** @type {(inputs: Calendar_Menu_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronizovat s kalendářem`)
};

const en_calendar_menu_sync = /** @type {(inputs: Calendar_Menu_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sync to calendar`)
};

/**
* | output |
* | --- |
* | "Sync to calendar" |
*
* @param {Calendar_Menu_SyncInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_menu_sync = /** @type {((inputs?: Calendar_Menu_SyncInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Menu_SyncInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_menu_sync(inputs)
	return cs_calendar_menu_sync(inputs)
});